import React from "react";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import styles from "./DeleteProfile.module.scss";
import { DeactivateIcon } from "../../../../assets/icons/svgicons";

const DeleteProfile = ({ show, handleClose, handleDeactivateAccount }) => {
  return (
    <Modal
      show={show}
      handleClose={handleClose}
      title="Deactivate account"
      className={styles.delete_profile}
    >
      <div className={styles.delete_img}>
        <DeactivateIcon />
      </div>
      <h5>Do you want to Deactivate this account?</h5>
      <div className={styles.action}>
        <Button variant="bordered_grey" fluid onClick={handleClose}>
          Go Back
        </Button>
        <Button variant="danger_filled" fluid onClick={handleDeactivateAccount}>
          Deactivate
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteProfile;
